module.exports = __webpack_public_path__ + "img/002.28f1784c.jpg";